// Module
var code = "{{$parent.row['score'] | number : 2}}\n";
// Exports
module.exports = code;